/* k8s environment detection - externalized for CSP compliance */
window.k8sEnv = !1;
